import { render } from "./WorkspaceLogo.vue?vue&type=template&id=7acf05e8"
import script from "./WorkspaceLogo.vue?vue&type=script&lang=js"
export * from "./WorkspaceLogo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__